/* unplugin-vue-components disabled */import script from "./OrderDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderDetail.vue?vue&type=script&setup=true&lang=js"

import "./OrderDetail.vue?vue&type=style&index=0&id=a69aff4a&lang=scss"

const __exports__ = script;

export default __exports__